import { z } from 'zod/v4';

/**
 * One supplier's amfori last-synced timestamp, as returned by the bulk
 * network route. `lastSyncedAt` is the ISO string stored on the supplier's
 * self-reported `amfori_last_synced_at` answer (null when absent).
 */
export const AmforiSupplierLastSyncedSchema = z
  .object({
    companyId: z.string(),
    lastSyncedAt: z.string().nullable(),
  })
  .strict();

export type AmforiSupplierLastSynced = z.infer<
  typeof AmforiSupplierLastSyncedSchema
>;
